import { HomeTemplate } from 'components/templates/home'
import React from 'react'

export const Home: React.FC = () => {
  return <HomeTemplate />
}
